<template>
    <div v-if="internalList">
        <div style="margin-bottom: .5em;margin-right: 0;">
            <span style="margin-right: 5px;">{{ S0008 }}</span>
            <input style="width: 25em;" v-model="textToSearch" @input="searchString" />
            {{ internalList.length }} / {{ total }}
        </div>

        <div style="display: flex; padding: 3px; padding: 3px;" class="testobianco backgroudlist">
            <div @click="orderList(-1, 0)" style="width: 70%;cursor: pointer; display: flex;">
                <div>
                    {{ S0009 }}
                </div>
                <div style="width: 24px;margin-left: 3px; margin-top: 2px;">
                    <img v-if="currentIdx == -1 && showArrowUp" src="../assets/up.png" />
                    <img v-if="currentIdx == -1 && showArrowDown" src="../assets/down.png" />
                </div>
            </div>
            <div v-for="(column, idx) in columns" :key="idx"
                style="display: flex; width: 200px; text-align: left;cursor: pointer; margin-right: 10px;" @click="orderList(idx, 0)">
                <div style="text-align: left;">
                    {{ column.description }}
                </div>

                <div style="width: 24px;margin-left: 3px; margin-top: 2px;">
                    <img v-if="currentIdx == idx && showArrowUp" src="../assets/up.png" />
                    <img v-if="currentIdx == idx && showArrowDown" src="../assets/down.png" />
                </div>
            </div>
        </div>

        <div style="overflow: auto; height: 38em;">
            <div v-for="(food, idx) in internalList" :key="idx" style="display: flex;" :class="!iseven(idx) ? 'even' : ''">
                <div style="width: 70%" class="link" @click="selectFood(food)">{{ food.description }}</div>

                <div v-if="columns.length > 0" style="width: 200px;text-align: left;">{{
                    calculateValue(food.componentCol1Value, food.componentCol1NrDec) }}</div>
                <div v-if="columns.length > 1" style="width: 200px;text-align: left;">{{
                    calculateValue(food.componentCol2Value, food.componentCol2NrDec) }}</div>
                <div v-if="columns.length > 2" style="width: 200px;text-align: left;">{{
                    calculateValue(food.componentCol3Value, food.componentCol3NrDec) }}</div>

            </div>
        </div>

    </div>
</template>
    
<script>
import { getSTRING } from '@/js/utils';

export default {
    name: "FoodAdvancedResult",
    props: ["resultData", "columns", "lang"],
    emits: { selectFood: null },
    data() {
        return {
            internalList: null,
            textToSearch: '',
            S0008: '',
            S0009: '',
            order: 'A',
            currentIdx: -1,
            showArrowUp: true,
            showArrowDown: false,
            total:0
        }
    },
    mounted() {
        this.S0008 = getSTRING(this.lang, "S0008", "Ricerca:")
        this.S0009 = getSTRING(this.lang, "S0009", "Alimento")
        this.internalList = this.resultData;
        this.total = this.resultData.slice().length;
    },
    methods: {
        iseven(num) {
            return num % 2 == 0;
        },
        calculateValue(value, dec) {
            
            if (value != -9999) {
                var val = parseFloat(value);    
                 
                    return val.toFixed(dec);                    
                 

            }
            else {                    
                return 'tr';
            }
            
        },
        searchString() {
            if (this.textToSearch != '') {
                this.internalList = this.resultData.slice().filter(f => f.description.toLowerCase().indexOf(this.textToSearch.toLowerCase()) === 0);
            }
            else {
                this.internalList = this.resultData.slice();
            }           
            this.orderList(this.currentIdx, 1);
        },
        orderList(idxColumn, isSame) {
            if (this.currentIdx != idxColumn) {
                this.currentIdx = idxColumn;
                this.order = "A"
                this.showArrowUp = true;
                this.showArrowDown = false;
            }
            else {
                if (isSame == 0) {
                    if (this.order == "A") {
                        this.order = "D"
                        this.showArrowUp = false;
                        this.showArrowDown = true;
                    }
                    else {
                        this.order = "A"
                        this.showArrowUp = true;
                        this.showArrowDown = false;
                    }
                }
            }
            if (this.order == "A") {
                this.internalList = this.internalList.sort((a, b) => {
                    let fa, fb
                    if (this.currentIdx == -1) {
                        fa = a.description.toLowerCase(), fb = b.description.toLowerCase();
                    }
                    if (this.currentIdx == 0) {
                        fa = a.componentCol1Value, fb = b.componentCol1Value;
                    }
                    if (this.currentIdx == 1) {
                        fa = a.componentCol2Value, fb = b.componentCol2Value;
                    }
                    if (this.currentIdx == 2) {
                        fa = a.componentCol3Value, fb = b.componentCol3Value;
                    }

                    if (fa < fb) {
                        return -1
                    }
                    if (fa > fb) {
                        return 1
                    }
                    return 0
                });
            }
            else {
                this.internalList = this.internalList.sort((a, b) => {
                    let fa, fb
                    if (this.currentIdx == -1) {
                        fa = a.description.toLowerCase(), fb = b.description.toLowerCase();
                    }
                    if (this.currentIdx == 0) {
                        fa = a.componentCol1Value, fb = b.componentCol1Value;
                    }
                    if (this.currentIdx == 1) {
                        fa = a.componentCol2Value, fb = b.componentCol2Value;
                    }
                    if (this.currentIdx == 2) {
                        fa = a.componentCol3Value, fb = b.componentCol3Value;
                    }

                    if (fa < fb) {
                        return 1
                    }
                    if (fa > fb) {
                        return -1
                    }
                    return 0
                });
            }

        },
        selectFood(food) {
            this.$emit("selectFood", food);
        }
    },
    watch: {
        resultData: {
            handler(val) {
                if (val) {
                    this.internalList = val.slice();
                    this.total = this.resultData.slice().length;
                }
                else {
                    this.internalList = null;
                }
            },
            deep: true
        }
    }
};
</script>
    
<style scoped>
.even {
    background-color: azure;
}
</style>